import { render, staticRenderFns } from "./Componenti.vue?vue&type=template&id=fea1e358&scoped=true&"
import script from "./Componenti.vue?vue&type=script&lang=js&"
export * from "./Componenti.vue?vue&type=script&lang=js&"
import style0 from "./Componenti.vue?vue&type=style&index=0&id=fea1e358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea1e358",
  null
  
)

export default component.exports